export const hex_to_RGB = (hex: string | undefined) => {
  if (!hex) {
    return {
      r: 0,
      g: 0,
      b: 0,
    };
  }

  const m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
  if (!m) {
    return {
      r: 0,
      g: 0,
      b: 0,
    };
  }
  return {
    r: parseInt(m[1], 16),
    g: parseInt(m[2], 16),
    b: parseInt(m[3], 16),
  };
};

export const calculateLuminance = (hex: string): number => {
  const { r: r8, g: g8, b: b8 } = hex_to_RGB(hex);

  const rS = r8 / 255;
  const gS = g8 / 255;
  const bS = b8 / 255;

  const r = rS <= 0.03928 ? rS / 12.92 : Math.pow((rS + 0.055) / 1.055, 2.4);
  const g = gS <= 0.03928 ? gS / 12.92 : Math.pow((gS + 0.055) / 1.055, 2.4);
  const b = bS <= 0.03928 ? bS / 12.92 : Math.pow((bS + 0.055) / 1.055, 2.4);

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance;
};

export const calculateContrastRatio = (hex1: string, hex2: string): number => {
  const luminance1 = calculateLuminance(hex1);
  const luminance2 = calculateLuminance(hex2);

  const L1 = Math.max(luminance1, luminance2) + 0.05;
  const L2 = Math.min(luminance1, luminance2) + 0.05;

  return L1 / L2;
};
